var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-form',{ref:"k-form"},[_c('v-container',{attrs:{"grid-list-md":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_vm._t("default")],2)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }